/* eslint-disable import/no-anonymous-default-export */
import { useState } from 'react';
import { Link } from "react-router-dom";
import "./GenAIEnclosure.css"

export default function (props) {

    const [isOpen, setOpenDescriptor] = useState(false);
    const {
        enclosureDocID, enclosureTitle, downloadURL, item, orderedFor, orderedBy
    } = props
    return (

          <div className="gen-ai-key-enclosure">
                <div className="gen-ai-key-enclosure__badge">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <title>The content included in the Enclosure field.</title>
                        <g clip-path="url(#clip0_1446_8959)">
                            <path d="M8.00016 10.6666V7.99992M8.00016 5.33325H8.00683M14.6668 7.99992C14.6668 11.6818 11.6821 14.6666 8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99992C1.3335 4.31802 4.31826 1.33325 8.00016 1.33325C11.6821 1.33325 14.6668 4.31802 14.6668 7.99992Z" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_1446_8959">
                                <rect width="16" height="16" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                    <span className="gen-ai-key-enclosure__badge-label">Enclosure</span>
                    <svg style={isOpen ? { transform: "rotate(180deg)", cursor: "pointer" } : { cursor: "pointer" }} onClick={e => setOpenDescriptor(!isOpen)} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 6L8 10L12 6" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                {isOpen && <div className="gen-ai-key-enclosure__card" role="region">
                    <div className="gen-ai-key-enclosure__list">
                        
                            <div
                                className="gen-ai-key-enclosure__row"
                                role="row"
                            >
                                 <Link
                            id={`docdata${enclosureDocID}`}
                            to={downloadURL}
                            target="_blank"
                            onClick={props.indexData}
                            data-title={item.docTitle}
                            data-products={item.tempJNJDrugs}
                            data-docnumber={item.documentNumber}
                            data-contentsource={item.domain}
                            data-docid={item.searchID}
                            data-doctype={item.docType}
                            data-docurl={downloadURL}
                            data-doclastmodified={item.createdDate}
                            data-orderedby={orderedBy}
                            data-orderedfor={orderedFor}
                        >
                            {enclosureTitle}
                        </Link>
                            </div>
                        
                    </div>
                </div>}

            </div>


        // <div className="document-descriptor-wrapper">
        //     <div className="document-descriptor-header-wrapper" onClick={e => setOpenDescriptor(!isOpen)}>
        //         <img src={desArrow} alt='desArrow' className={isOpen ? "document-descriptor-img-rotate" : "document-descriptor-img"} onClick={e => setOpenDescriptor(!isOpen)} />
        //         <span> Enclosure</span>
        //         <img src={infoIcn} alt='infoIcn' className="keyTakeaways-info-icn" title="The content included in the Enclosure field" />
        //     </div>
        //     {isOpen &&
        //         <div className="document-descriptor-text-wrapper">
        //             <Link
        //                 id={`docdata${enclosureDocID}`}
        //                 to={downloadURL}
        //                 target="_blank"
        //                 onClick={props.indexData}
        //                 data-title={item.docTitle}
        //                 data-products={item.tempJNJDrugs}
        //                 data-docnumber={item.documentNumber}
        //                 data-contentsource={item.domain}
        //                 data-docid={item.searchID}
        //                 data-doctype={item.docType}
        //                 data-docurl={downloadURL}
        //                 data-doclastmodified={item.createdDate}
        //                 data-orderedby={orderedBy}
        //                 data-orderedfor={orderedFor}
        //             >
        //                 {enclosureTitle}
        //             </Link>
        //         </div>
        //     }
        // </div>
    )
}